<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('staff members')"
      :columns="columns"
      :column_search="true"
      resource_url="/staff/member/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/staff/settings' })"
        >
          <span class="icon"><i class="fa fa-cogs"></i></span>
          <span>{{ $t("settings") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <member-modal
      ref="member_modal"
      :module_settings="module_settings"
      @success="refresh"
    />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
  format_date,
} from "@/utils";
import MemberModal from "./member_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "StaffMemberDatatable",
  components: { GenericTable, MemberModal },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("admission date"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            if (row.admission_date) return format_date(row.admission_date);
            else return "";
          },
        },
        {
          title: v.$t("name"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${row.first_name || ""} ${
              row.second_name || ""
            } ${row.first_surname || ""} ${row.second_surname || ""}</div>
            <div class="subtitle is-7">${format_date(row.birth_date)}</div>`;
          },
        },
        {
          title: v.$t("internal id"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${
              row.internal_id_number || ""
            }</div>
            <div class="subtitle is-7">${
              row.modul_user ? row.modul_user.username : ""
            } ${row.status ? row.status.name : ""}</div>`;
          },
        },
        {
          title: v.$t("custom fields"),
          searchable: false,
          // width: "55%",
          data: (row) => {
            if (v.module_settings && v.module_settings.custom_fields) {
              let shown_fields = v.module_settings.custom_fields.filter(
                (field) => field.show_in_table
              );
              // return truncate(JSON.stringify(row), { length: 65 });
              let r = row.settings.custom_fields
                .filter(
                  (field) =>
                    shown_fields.find((f) => f.name === field.name) &&
                    field.value
                )
                .reduce((acc, field) => {
                  return `${acc}<div class="subtitle is-7 mb-0">${field.name}: ${field.value}</div>`;
                  // let f = shown_fields.find((f) => f.name === field.name);
                  // return `${acc}<div class="subtitle is-7">${f.label}: ${field.value}</div>`;
                }, "");
              return r;
            } else {
              return "";
            }
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "55%",
        //   data: (row) => {
        //     // return truncate(JSON.stringify(row), { length: 65 });
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.member_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete staff member?"),
                    v,
                    () => {
                      del("/staff/member", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.member_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
